module.exports = __webpack_public_path__ + "img/br.0a50be6f.svg";